import { Fragment/*, useEffect, useState*/ } from 'react';
import { Helmet } from 'react-helmet';
import { Root } from './components';
//import NewRoot from './components/NewRoot';

const App = () => {
    //const [theBeast, setTheBeast] = useState<boolean>(false);

    //useEffect(() => {
    //    const handler = ({ target, code, shiftKey }: KeyboardEvent) => {
    //        if (target === document.body && code === 'KeyB' && shiftKey === true) {
    //            setTheBeast((theBeast) => !theBeast);
    //        }
    //    };

    //    document.addEventListener('keyup', handler);

    //    return () => {
    //        document.removeEventListener('keyup', handler)
    //    }
    //}, [setTheBeast]);

    return (
        <Fragment>
            <Helmet>
                <title>Hacpack 2020</title>
            </Helmet>

            {/*{ theBeast? <NewRoot /> : <Root /> }*/}
            <Root/>
        </Fragment>
    );
}

export default App;
